const _coworkTableSizeAndInputs = function () {
  let foundLabel = null;

  // Získání všech inputů s atributem name="size"
  const radios = document.querySelectorAll(
    '.product-form__input input[type="radio"][name^="Size"]:not(.disabled)'
  );
  const checkedRadio = document.querySelector(
    '.product-form__input input[type="radio"][name^="Size"]:checked'
  );
  const labels = document.querySelectorAll(".product-form__input label");

  // Vytvoření pole hodnot z radio inputů
  const radioValues = Array.from(radios).map((radio) => radio.value);

  _UNCS_removeClassFromElements("#tabulka-velikosti tbody tr", "tr-aktivni");
  _UNCS_removeClassFromElements("#tabulka-velikosti tbody tr", "tr-vyprodany");

  // Získání všech řádků v tbody tabulky #tabulka-velikosti
  const rows = document.querySelectorAll("#tabulka-velikosti tbody tr");
  rows.forEach((row) => {
    // Získání hodnoty z prvního sloupce řádku
    var cellValue = row.cells[0].innerText.trim();
    cellValue = cellValue.replace(/<[^>]*>\s*.*?\s*<\/[^>]+>/gs, "").trim().replace(' ', '');
    var radioVal = (checkedRadio?.value ?? '').trim();
    radioVal = radioVal.replace(/<[^>]*>\s*.*?\s*<\/[^>]+>/gs, "").trim().replace(' ', '');
    if (cellValue == radioVal) {
      row.classList.add("tr-aktivni");
    }
    _UNCS_addListenerRowSize(row, radioValues, cellValue, labels);
  });
};

const _UNCS_addListenerRowSize = function (
  row,
  radioValues,
  cellValue,
  labels
) {
  const clonedRow = row.cloneNode(true); // vytvoří kopii řádku včetně všech vnořených elementů

  row.parentNode.replaceChild(clonedRow, row);
  row = clonedRow;
  cellValue = cellValue.replace(/<[^>]*>\s*.*?\s*<\/[^>]+>/gs, "").trim().replace(' ', '');

  // Kontrola, zda hodnota prvního sloupce odpovídá některému z radio inputů
  if (radioValues.includes(cellValue)) {
    row.addEventListener("click", function () {
      labels.forEach((label) => {
        //labelText = label.innerHTML.replace(/<[^>]*>.*?<\/[^>]+>/gs, "").trim();
        labelText = label.innerHTML.replace(/<[^>]*>\s*.*?\s*<\/[^>]+>/gs, "").trim();
        if (labelText === cellValue) {
          console.log(cellValue);
          label.click();
          modal.style.display = "none";
        }
      });
    });
  } else {
    row.classList.add("tr-vyprodany");
  }
};

const _UNCS_removeClassFromElements = function (elements, className) {
  if (elements == "") {
    return;
  }
  if (className == "") {
    return;
  }
  // Ziskani vsech elementu v del elements
  const els = document.querySelectorAll(elements);
  if (!els) {
    return;
  }

  // Iterace přes všechny elementy a odstranění třídy className
  els.forEach((el) => {
    el.classList.remove(className);
  });
};

function _uncs_tabulkaVelikostiOnLoad() {
  // Get the modal
  var modal = document.getElementById("tabulkaVelikostiPopUp");

  // Get the button that opens the modal
  var btn = document.getElementById("uncs-showTabulkaVelikosti");

  // Get the <span> element that closes the modal
  var span = document.getElementById("uncs-closeTabulkaVelikosti");

  // When the user clicks the button, open the modal
  if (btn) {
    btn.onclick = function () {
      _coworkTableSizeAndInputs();
      modal.style.display = "block";
    };
  };

  // When the user clicks on modal, close the modal
  modal.addEventListener("click", function (event) {
    const path = event.composedPath();

    // Procházíme cestu události
    for (let element of path) {
      if (element.tagName === "TR") {
        return;
      } // Pokud je některý z předků <tr>, ukončíme funkci
    }
    modal.style.display = "none";
  });

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };

  const element = document.getElementById('uncs-showTabulkaVelikosti');
        
  // Ověření, zda byl element nalezen
  if (element) {
    // Uložení výchozí barvy pozadí
    const originalBackground = 'rgba(var(--color-button), .8)';
            
    function animateBackground() {
      // Změna barvy pozadí na oranžovou
      element.style.backgroundColor = 'var(--uncs-orange)';

      // Po čase změň barvu zpět na výchozí
      setTimeout(() => {
        element.style.background = originalBackground;
        setTimeout(() => {
          element.style.background = originalBackground;
        }, 400);
      }, 2000);     
    }

    animateBackground(); // Spusť animaci
  } else {
    console.error('Element s id "uncs-showTabulkaVelikosti" nebyl nalezen.');
  }
}

// probliknutí barev tlačítka na tabulku velikostí
document.addEventListener('DOMContentLoaded', _uncs_tabulkaVelikostiOnLoad);
subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, _uncs_tabulkaVelikostiOnLoad);
subscribe(PUB_SUB_EVENTS.variantChange, _uncs_tabulkaVelikostiOnLoad);